import toString from 'lodash/toString';
import { SUBMITTING_SLIDER_FORM ,
  FETCH_EVENTS_FOR_PAGE,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  FETCH_BOOKING_FAILURE,
  FETCH_BOOKING_SUCCESS,
  FETCH_BOOKINGS_FOR_PAGE,
  UPDATE_VISIT,
  FETCH_BASE_PARAMS,
  FETCH_LOCATION_PARAMS,
  FETCHING_BUNDLE,
  FETCH_BUNDLE,
  FETCHING_EVENT,
  FETCH_EVENT,
  FETCH_RECOMMENDED_VENUESV1,
  FETCH_RECOMMENDED_VENUESV2,
  LOADING_RECO_VENUE_LIST,
  LOAD_RECO_VENUE_LIST,
  CONFIRMING_BOOKING,
  UPDATE_FEEDBACK,
  UPDATING_FEEDBACK,
  UPDATE_BASE_PARAMS_STATE,
  UPDATE_LOCATION_PARAMS_STATE,
  UPDATE_EVENT,
  UPDATING_EVENT,
  UPDATE_RECO_COUNT,
  PLANING_VISIT,
  SET_EVENT_ID,
  LOADING_RECO_PAGE,
  LOAD_RECO_PAGE, LOADING_VENUE_ASSETS_DATA,
  LOAD_VENUE_ASSETS_DATA,
  UPDATING_MANAGER_DETAILS_SEEN, SENDING_MANAGER_DETAILS_SMS,
  UPDATE_ASSET_PACKAGE, ADD_ASSET_VISIT, UPDATING_ASSET_PACKAGE,
  UPDATING_VENUE_ITEM, REJECTING_VENUE_BY_USER,
  SUBMITTING_LEAD_FORM,
  FETCH_MAGIC_TOKEN,
  EVENT_BROADCASTED_TO_AGENT,
  BOOKING_REQUEST_SENT,
  PLAN_VISIT_STATE,
  REQUEST_BOOKING_STATE,
  SHORTLISTED_VENUE_OBJECT,
  REQUEST_BOOKING_SUCCESS_STATE,
  PLAN_VISIT_SUCCESS_STATE,
  IS_PLANNING_VENUE_TOUR,
  AGENT_DETAILS,
  VISIT_UPDATE_DATA,
  PLAN_VISIT_EDIT_STATE,
  FETCH_AGENT_DETAILS,
  FETCH_HEAVY_DATE,
  FETCH_BOOKING_VISIT_COUNT_VISIBLE,
  EVENTS_COUNT,
  SCHEDULE_CALL_MODAL_STATE,
  PLANNED_VISIT_DETAILS,
  FETCH_MONTHLY_WINNER,
  FETCH_LEADERBOARD_DATA,
  GET_REVIEW_TICKTES,
  FETCH_DATA_LOADING_STATE,
  TICKET_LOADING_STATE
} from '../actions/EventActions';
// Import Actions
// import {

// } from './EventActions';

// Initial State
const initialState = {
  list: [],
  listCount: 0,
  currentEventPage: 1,
  isLoading: false,
  bookings: [],
  bookingsCount: 0,
  currentBookingPage: 1,
  isSaving: false,
  isFetchingVenues: false,
  isFetchingEvent: false,
  isFetchingBundle: false,
  eventid: '',
  event: {},
  bundle: {},
  cities: [],
  locations: [],
  packages: [],
  occasions: [],
  venuetypes: [],
  recoVenueCount: 0,
  isLoadingBaseParams: false,
  isLoadingLocationParams: false,
  isSavingEventInfo: false,
  isSendingCallBack: false,
  showCallbackSection: false,
  venues: [],
  filters: {},
  currentPage: 1,
  pageSize: 12,
  contacts: [],
  isLoadingVenueList: false,
  isCreatingVisit: false,
  showBookingModal: false,
  isConfirmingBooking: false,
  isBookingRequestSent: false,
  feedback: {},
  isLoadingRecoPage: true,
  assets: {},
  isLoadingAssets: false,
  isRejectingVenue: false,
  isPlanningEvent: false,
  magicToken:'',
  isEventBroadcastedToAgent:false,
  isRequestBookingOverlayOpen: false,
  isRequestBookingSuccessOverlayOpen: false,
  isPlanVisitOverlayOpen: false,
  isPlanVisitEditOverlayOpen: false,
  isPlanVisitSuccessOverlayOpen: false,
  venueShortlisted: {},
  visitUpdatedata: {},
  recoListCombinedV1: [],
  recoListCombinedV2:[],
  isSavingVisit: false,
  toggleForAssetChange: false,
  visit: {},
  venueTourLoader:false,
  heavyDate: null,
  isBookingvisitcount:{},
  eventsCount : 0,
  is_schedule_call_modal_visible :false,
  visitDetails:{},
  monthlywinners:{},
  monthlyleaderboarddata:[],
  tickets:{},
  leaderdataloading: false,
  ticketsloading: false
};

const EventReducers = (state = initialState, action) => {
  let bundle = {};
  // let assets = {};
  switch (action.type) {

    case SCHEDULE_CALL_MODAL_STATE : 
         return {
            ...state,
            is_schedule_call_modal_visible:action.is_schedule_call_modal_visible
         }

     case EVENTS_COUNT : 
        return {
            ...state,
            eventsCount:action.eventsCount
        }

      case FETCH_HEAVY_DATE :
        return{
            ...state,
            heavyDate:action.date
        }

     case FETCH_MONTHLY_WINNER :
            return{
                ...state,
                monthlywinners:action.monthlywinners
            }
            case FETCH_DATA_LOADING_STATE :
                return{
                    ...state,
                    leaderdataloading:action.leaderdataloading
                }
                case FETCH_LEADERBOARD_DATA :
                    return {
                        ...state,
                        monthlyleaderboarddata: action.monthlyleaderboarddata
                        }
                    
                
                
     case GET_REVIEW_TICKTES :
            return{
                ...state,
                tickets:action.tickets
                    }

                    case TICKET_LOADING_STATE :
                        return{
                            ...state,
                            ticketsloading:action.ticketsloading
                                }                    
        case FETCH_BOOKING_VISIT_COUNT_VISIBLE:
            return {
                ...state,
                isBookingvisitcount: action.isBookingvisitcount,
            };  
      case SUBMITTING_SLIDER_FORM:
          return {
              ...state,
              isPlanningEvent: action.isPlanningEvent,
          };
      case FETCH_RECOMMENDED_VENUESV1:
          return {
              ...state,
              recoListCombinedV1: action.recoListCombinedV1,
          };
      case FETCH_RECOMMENDED_VENUESV2:
          return {
              ...state,
              recoListCombinedV2: action.recoListCombinedV2,
          };
          case AGENT_DETAILS:
            return {
                ...state,
                agentDetails: action.payload,
                error: null,
            };    
      case UPDATE_VISIT:
          return {
              ...state,
              assets: action.assets,
              toggleForAssetChange: !state.toggleForAssetChange,
              isSavingVisit: action.isSavingVisit,
          };
      case SUBMITTING_LEAD_FORM:
          return {
              ...state,
              isPlanningEvent: action.isPlanningEvent,
          };

      case FETCH_EVENTS_FOR_PAGE:
          return {
              ...state,
              isLoading: action.isLoading,
              currentEventPage: action.currentEventPage,
          };

      case FETCH_EVENTS_SUCCESS:
          return {
              ...state,
              isLoading: action.isLoading,
              list: action.list,
              listCount: action.listCount,
          };

      case FETCH_EVENTS_FAILURE:
          return {
              ...state,
              isLoading: action.isLoading,
          };

      case FETCH_BOOKINGS_FOR_PAGE:
          return {
              ...state,
              isLoading: action.isLoading,
              currentBookingPage: action.currentBookingPage,
          };

      case FETCH_BOOKING_SUCCESS:
          return {
              ...state,
              isLoading: action.isLoading,
              bookings: action.bookings,
              bookingsCount: action.bookingsCount,
          };

      case FETCH_BOOKING_FAILURE:
          return {
              ...state,
              isLoading: action.isLoading,
          };
          case FETCH_AGENT_DETAILS:
            return {
                ...state,
                isLoading: action.isLoading,
            };
      case FETCHING_EVENT:
          return {
              ...state,
              isFetchingEvent: action.isFetchingEvent,
          };

      case FETCH_EVENT:
          return {
              ...state,
              isFetchingEvent: action.isFetchingEvent,
              isPlanningEvent: action.isPlanningEvent,
              event: action.event,
          };

      case FETCHING_BUNDLE:
          return {
              ...state,
              isFetchingBundle: action.isFetchingBundle,
          };


      case IS_PLANNING_VENUE_TOUR :
        return{
          ...state,
          venueTourLoader:action.venueTourLoader
        }

    case FETCH_BUNDLE:
      return {
        ...state,
        isFetchingBundle: action.isFetchingBundle,
        bundle: action.bundle,
      };

      case UPDATE_BASE_PARAMS_STATE:
          return {
              ...state,
              isLoadingBaseParams: action.isLoadingBaseParams,
          };

      case UPDATE_LOCATION_PARAMS_STATE:
          return {
              ...state,
              isLoadingLocationParams: action.isLoadingLocationParams,
          };

      case FETCH_BASE_PARAMS:
          return {
              ...state,
              isLoadingBaseParams: action.isLoadingBaseParams,
              packages: action.packages,
              occasions: action.occasions,
              venuetypes: action.venuetypes,
              cities: action.cities,
          };

      case FETCH_LOCATION_PARAMS:
          return {
              ...state,
              isLoadingLocationParams: action.isLoadingLocationParams,
              locations: action.locations,
          };

      case UPDATING_EVENT:
          return {
              ...state,
              isSavingEventInfo: action.isSavingEventInfo,
          };

      case UPDATE_EVENT:
          return {
              ...state,
              isSavingEventInfo: action.isSavingEventInfo,
              event: action.event,
          };

      case LOADING_RECO_VENUE_LIST:
          return {
              ...state,
              isLoadingVenueList: action.isLoadingVenueList,
          };

      case LOAD_RECO_VENUE_LIST:
          return {
              ...state,
              isLoadingVenueList: action.isLoadingVenueList,
              venues: action.venues,
              recoVenueCount: action.recoVenueCount,
          };

      case PLANING_VISIT:
          return {
              ...state,
              isCreatingVisit: action.isCreatingVisit,
          };

      case CONFIRMING_BOOKING:
          return {
              ...state,
              isConfirmingBooking: action.isConfirmingBooking,
          };
      case BOOKING_REQUEST_SENT:
          return {
              ...state,
              isBookingRequestSent: action.isBookingRequestSent,
          };
      case UPDATING_FEEDBACK:
          return {
              ...state,
              isSaving: action.isSaving,
          };

      case UPDATE_FEEDBACK:
          return {
              ...state,
              isSaving: action.isSaving,
              feedback: action.feedback,
          };

      case UPDATE_RECO_COUNT:
          return {
              ...state,
              recoVenueCount: action.recoVenueCount,
          };

      case LOADING_RECO_PAGE:
          return {
              ...state,
              isLoadingRecoPage: action.isLoadingRecoPage,
          };

      case LOAD_RECO_PAGE:
          return {
              ...state,
              isLoadingRecoPage: action.isLoadingRecoPage,
              isFetchingBundle: action.isFetchingBundle,
              bundle: action.bundle,
              isLoadingBaseParams: action.isLoadingBaseParams,
              packages: action.packages,
              occasions: action.occasions,
              venuetypes: action.venuetypes,
              cities: action.cities,
              isLoadingLocationParams: action.isLoadingLocationParams,
              locations: action.locations,
          };

      case SET_EVENT_ID:
          return {
              ...state,
              eventid: action.eventid,
          };

      case LOADING_VENUE_ASSETS_DATA:
          return {
              ...state,
              isLoadingAssets: action.isLoadingAssets,
          };

      case LOAD_VENUE_ASSETS_DATA:
          return {
              ...state,
              isLoadingAssets: action.isLoadingAssets,
              assets: action.assets,
          };

      case UPDATING_MANAGER_DETAILS_SEEN:
          bundle = state.bundle;
          if (bundle.venueList) {
              bundle.venueList = bundle.venueList.map((item) => {
                  if (toString(item.uid._id) === toString(action.venueId)) {
                      item.isUpdatingManagerDetailsSeen = action.isLoading;
                      item.isContactSeenByUser = action.isContactSeenByUser;
                  }
                  return item;
              });
          }
          return {
              ...state,
              bundle: bundle,
          };

      case SENDING_MANAGER_DETAILS_SMS:
          bundle = state.bundle;
          if (bundle.venueList) {
              bundle.venueList = bundle.venueList.map((item) => {
                  if (toString(item.uid._id) === toString(action.venueId)) {
                      item.isSmsSent = action.isSmsSent;
                      item.isSendingSms = action.isSendingSms;
                  }
                  return item;
              });
          }
          return {
              ...state,
              bundle: bundle,
          };

      case UPDATING_VENUE_ITEM:
          bundle = state.bundle;
          if (bundle.venueList) {
              bundle.venueList = bundle.venueList.map((item) => {
                  if (toString(item.uid._id) === toString(action.venueId)) {
                      item[action.keyName] = action.value;
                  }
                  return item;
              });
          }
          return {
              ...state,
              bundle: bundle,
          };

      case UPDATING_ASSET_PACKAGE:
          assets = state.assets;
          if (assets[action.venueId] && assets[action.venueId].subpackages) {
              assets[action.venueId].subpackages = assets[action.venueId].subpackages.map(
                  (item) => {
                      if (toString(item._id) === toString(action.packId)) {
                          item.isUpdating = action.isUpdating;
                      }
                      return item;
                  }
              );
          }
          return {
              ...state,
              assets: assets,
          };

      case UPDATE_ASSET_PACKAGE:
          assets = state.assets;
          if (assets[action.venueId] && assets[action.venueId].subpackages) {
              assets[action.venueId].subpackages = assets[action.venueId].subpackages.map(
                  (item) => {
                      if (toString(item._id) === toString(action.packId)) {
                          return action.pack;
                      } else {
                          return item;
                      }
                  }
              );
          }
          return {
              ...state,
              assets: assets,
          };

      case ADD_ASSET_VISIT:
          assets = state.assets;
          if (assets[action.venueId] && assets[action.venueId].visits) {
              assets[action.venueId].visits.push(action.visit);
          } else if (assets[action.venueId]) {
              assets[action.venueId] = {};
              assets[action.venueId].visits = [];
              assets[action.venueId].visits.push(action.visit);
          }
          return {
              ...state,
              assets: assets,
          };

      case REJECTING_VENUE_BY_USER:
          return {
              ...state,
              isRejectingVenue: action.isRejectingVenue,
          };
      case EVENT_BROADCASTED_TO_AGENT:
          return {
              ...state,
              isEventBroadcastedToAgent: action.isEventBroadcastedToAgent,
          };
      case REQUEST_BOOKING_STATE:
          return {
              ...state,
              isRequestBookingOverlayOpen: action.isRequestBookingOverlayOpen,
          };
      case REQUEST_BOOKING_SUCCESS_STATE:
          return {
              ...state,
              isRequestBookingSuccessOverlayOpen: action.isRequestBookingSuccessOverlayOpen,
          };
      case PLAN_VISIT_STATE:
          return {
              ...state,
              isPlanVisitOverlayOpen: action.isPlanVisitOverlayOpen,
          };
      case PLANNED_VISIT_DETAILS:
          return {
              ...state,
              visitDetails: action.visitDetails,
          };
          case PLAN_VISIT_EDIT_STATE:
            return {
                ...state,
                isPlanVisitEditOverlayOpen: action.isPlanVisitEditOverlayOpen,
            };    
      case PLAN_VISIT_SUCCESS_STATE:
          return {
              ...state,
              isPlanVisitSuccessOverlayOpen: action.isPlanVisitSuccessOverlayOpen,
          };
      case SHORTLISTED_VENUE_OBJECT:
          return {
              ...state,
              venueShortlisted: action.venueShortlisted,
          };
          case VISIT_UPDATE_DATA:
            return {
                ...state,
                visitUpdatedata: action.visitUpdatedata,
            };    
      default: 
          return state;
  }
};

// Export Reducer
export default EventReducers;
